// Single-source visibility flags. Flip the matching env var in /app/frontend/.env
// (then restart frontend) to instantly restore hidden surfaces.
//
//   REACT_APP_HIDE_BOTTLES=true   → hide every bottle photo + the SVG
//                                    deconstruction sequence + Gallery grid.

export const BOTTLES_HIDDEN = process.env.REACT_APP_HIDE_BOTTLES === "true";
